import axios from 'axios';
import config from './config';
import message from "antd/es/message/index";
import { dataLoaded, dataLoading } from 'actions/data.action';
import { logout } from 'actions/auth.action.js';


class AjaxService {

    constructor(store,history) {

        this.instance = axios.create({
            baseURL: config.serverUrl,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });

        this.instance.interceptors.request.use((config) => {
            if (config.url.indexOf("/users/profile")==-1 && config.url.indexOf("/smspart")==-1){
                store.dispatch(dataLoading());
            }
            const user = JSON.parse(localStorage.getItem('user'));
            if (user && user.token) {
                config.headers['token'] = `${user.token}`;
            }
            return config;
        }, (error) => {
            store.dispatch(dataLoaded());
            return Promise.reject(error);
        });

        this.instance.interceptors.response.use((response) => {
            if (response.request.responseURL.indexOf("/users/profile")==-1 && response.request.responseURL.indexOf("/smspart")==-1){
                store.dispatch(dataLoaded());
            }    
            //UNAUTHORIZED(401, "Unauthorized"),
            if (response.status === 401) {
                //logout(store);
                store.dispatch(logout());
              
                history.push({
                  pathname: `/`,
                });
                window.location.href = "/Login";
                return;
                 
            }

            //	FORBIDDEN(403, "Forbidden"),
            if (response.status === 403 || response.data.status === 'forbidden')  {
                message.error("Bu Sayfaya Erisim Yetkiniz Bulunmamaktadir")
                history.push("/error/403")
            }

            if (response.headers['content-type'] === 'application/octet-stream') {
                return Promise.resolve(response.data);
            }
            if (response.status === 200 && response.data.responseCode >= 500) {
                
                return Promise.reject(response.data);
              }

            
            if (response.status === 200 && response.data.status !== 'error') {
                return Promise.resolve(response.data)
            } else {
                // store.dispatch(logoutUser(response.data.data.message));
            }
            if (response.status !== 200 && response.data) {
                return Promise.reject(response.data);  
            }

            if (response.status !== 200) {
                //message.error(`Please contact the system administrator ${response.message}`);
                return Promise.reject(response.status);

            } else {
                return Promise.reject(response.data);
            }
        }, (error) => {
            console.log("erorr geldi");
            store.dispatch(dataLoaded());
            if (error.message==="Network Error")
            {
               
                  return Promise.reject("Network Error");
            }
            if (error.response.status === 401) {
                store.dispatch(logout());
              
                  history.push({
                    pathname: `/`,
                  });
                  window.location.href = "/Login";
                return;
              }
            if (error.response.status === 500 && error.response.data.responseCode>500) {
                return Promise.reject(error.response.data);
              }
             
            if (!error.message) {
                error.message = "Internal Server Error";
            }
            return Promise.reject(error.message);
        });

    }

    get(url,config = {}) {
        return this.instance.get(url, config);
    }

    post(url, data, config={}) {
        return this.instance.post(url, data, config);
    }

    patch(url, data, config={}) {
        return this.instance.patch(url, data, config);
    }

    put(url, data) {
        return this.instance.put(url, data);
    }

    delete(url) {
        return this.instance.delete(url);
    }
}

export default AjaxService;